// Eventually will be acquired as a JSON instead of variable.
const supportedLocales = {
  'pt-BR': 'Português Brasileiro',
  en: 'English',
  es: 'Español'
}

/**
 * Returns the values from "supportedLocales" JSON to create an Array of
 * code/name for Supported Locales in the format [{ code: "en", name: "English"}]
 * @return [{Object}] - Locale Code / Locale Name
 */
export function getSupportedLocales () {
  const annotatedLocales = []
  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code]
    })
  }
  return annotatedLocales
}

/**
 * Checks if the locale is in the supportedLocales.
 * @param {String} locale - Locale Key
 * @return {Boolean} supported?
 */
export function supportedLocalesInclude (locale) {
  return Object.keys(supportedLocales).includes(locale)
}

/**
 * Uses the browser’s navigator.languages array to attempt to detect the user’s preferred locale.
 * @param {Object} options - Configuration options
 * @return {String} locale code
 */
export default function getBrowserLocale (options = {}) {
  const defaultOptions = { countryCodeOnly: false } // for pt-br, true would return only "pt", false returns "pt-br"
  const opt = { ...defaultOptions, ...options }
  const navigatorLocale =
      navigator.languages !== undefined
        ? navigator.languages[0] // Browser preferences
        : navigator.language // UI Language or the first element in navigator.languages
  if (!navigatorLocale) {
    return undefined // Language not found
  }
  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim()
  return trimmedLocale
}
